<template>
    <v-main class="justify-center" style="height: 100%; width: 100%; position: absolute;">
        <CardNav />
        <v-container>
            <v-row>
                <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh); width: calc(100svw - 2svw - 2svw); margin-top: 2svw; margin-bottom: 2svw; margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; flex-flow: column">
                    <div v-if="properPreparation == true">
                        <div class="dot" style="border-color: #6EBDAA;">
                            <p style="margin: auto; font-size: 20px; font-weight: 400;">Preparación <br> adecuada</p>
                        </div>
                        <p style="margin-top: -5.5svh; margin-left: 50svw;">verde</p>
                        <v-card
                            style="position: absolute; top: 78%; left: 5%; width: 90%; border: 1px solid #059BCA; border-radius: 6px;">
                            <p
                                style="padding-top: 5%; padding-bottom: 5%; font-family: Lato; color: #059BCA; text-align: center; font-size: 16px; font-weight: 400;">
                                Acuda a su cita médica prevista
                            </p>
                        </v-card>
                    </div>
                    <div v-else>
                        <div class="dot" style="margin-top: 12.5svh; border-color: #F88D7F;">
                            <p style="margin: auto; text-align: center;">Preparación <br> inadecuada</p>

                        </div>
                        <p style="margin-top: -5.5svh; margin-left: 50svw;">rojo</p>
                    </div>
                </v-card>
                <div v-if="properPreparation == true">
                    <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh)); width: calc(100svw - 2svw - 2svw); margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; align-items: center; flex-flow: row">
                    <v-btn elevation="12" v-on:click="click(0)"
                          style="margin-left: auto; margin-right: auto; width: 208px; height: 69px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                          <b>Finalizar</b>
                      </v-btn>
                    </v-card>
                </div>
                <div v-else>
                    <v-card elevation="12"
                    style="height: calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - calc(100svh - 13.4svh - 2svw - 2svw - 2svw - 2svw - 22.66svh)); width: calc(100svw - 2svw - 2svw); margin-left: 2svw; margin-right: 2svw; border-radius: 9px; display: flex; align-items: center; flex-flow: row">
                    <v-btn elevation="12" v-on:click="click(1)"
                          style="margin-left: auto; margin-right: auto; width: 208px; height: 69px; border: 1px solid #E9F6FB;
                          font-family: Lato; text-transform: unset !important; font-style: normal; background-color: #FFFFFF; color: #059BCA; font-size: 16px; box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25); border-radius: 6px;">
                          <b>Continuar</b>
                      </v-btn>
                    </v-card>
                </div>
            </v-row>
        </v-container>
    </v-main>
</template>

<script>

import CardNav from './CardNav.vue';
import { nextScreen, nextScreenWithParams } from '../router/utils.js';
import { preference } from "vue-preferences";

export default {
    name: 'ProperPreparation',
    components: {
        CardNav
    },
    data() {
        return {
            proper: false,
        }
    },
    computed: {
        properPreparation: {
            get: function () {
                return this.proper;
            },
            set: function (newValue) {
                this.proper = newValue;
            }
        },
    },
    methods: {
        matchHeight() {
            this.properPreparation = preference('properPreparation', { defaultValue: '' }).get();
        },
        click(number) {
            switch (number) {
                case 0:
                    nextScreenWithParams(this.$router, 'ProcessCompleted', true);
                    break;
                case 1:
                    nextScreen(this.$router, '/configtreatment');
                    break;
            }
        },
    },
    mounted() {
        this.matchHeight();
    }
}
</script>

<style>

.dot {
    box-sizing: border-box;
    margin-left: calc((100svw - 65svw - 2svw - 2svw) / 2);
    margin-top: 3.25svh;
    margin-bottom: 3.25svh;
    height: 65svw;
    width: 65svw;
    background-color: #FFFFFF;
    border-radius: 50%;
    display: flex;
    cursor: pointer;
    border: 30px solid;
}

</style>



// WEBPACK FOOTER //
// src/components/ProperPreparation.vue